//没有头部和尾部的页面
const router = [
  {
    path: "/login",
    meta: {
      title: "login",
    },
    component: (resolve) => require(["../views/login/login"], resolve),
  },
];

export default router;



// WEBPACK FOOTER //
// ./src/router/indexEmpty.js